module.exports = __webpack_public_path__ + "static/media/file.688e2abd.svg";